<template>
<section class="content">
    <div class="box box-info">
      <a href="#"   @click.prevent="exportCSV()" >
       <img src="../../../../static/img/excel.png" style="width: 4%;float: right;"/>
      </a>
    </div>
    <div>
    <DataTable ref="po"
      :value="balanceSettlementLists"
      :paginator="true"
      :rows="10"  :filters="filters"
      class="p-datatable-responsive-demo">
      <Column header="S.n" >
      <template #body="slotProps">
        {{slotProps.index+1}}
      </template>
      </Column>
      <Column :sortable="true"   header="Name" field="accountName" filterMatchMode="contains" >
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
      </template>
      </Column>
      <Column :sortable="true"
        header="Balance"
        field="balance"
        filterMatchMode="contains"
        bodyStyle="text-align: right"
      >
        <template #body="slotProps">
          {{slotProps.data.balance < 0? slotProps.data.balance * (-1):slotProps.data.balance}}
        </template>
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['balance']" />
      </template>
      </Column>

      <Column :sortable="true"
        header="Dr-Cr"
        field="drCr"
        filterMatchMode="contains"
      >
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['drCr']" />
      </template>
      </Column>
    </DataTable>
      <!-- <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-10"></div>
        <div class="p-field p-col-12 p-md-2 p-mt-2">
          <Button style="float:right"  class="p-button-raised p-button-success" label="Settle"
           @click.prevent="saveBroughtDown()"/> -->
           <!-- <Button v-else disabled style="float:right"  class="p-button-raised p-button-success" label="Settle"
           @click.prevent="settleSales()"/> -->
         <!-- </div>
       </div> -->
  <!-- <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster"/> -->
  </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'balanceBroughtDownSettlementList',
  data () {
    return {
      columnList: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button
  },
  computed: {
    balanceSettlementLists() {
      return this.$store.state.finalYearSettlement.balanceSettlementLists
    }
  },
  mounted() {
    this.balanceSettlementList()
    this.columnNames()
  },
  methods: {
    async balanceSettlementList() {
      try {
        await this.$store.dispatch('loadBalanceSettledList')
      } catch (e) {}
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Account List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'accountList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// fiscalYearSettledReport.vue?1fbbf558